import React from 'react';
import { MailIcon } from 'lucide-react';
const LOGO_IMG = 'https://cdn.magicpatterns.com/uploads/iiWygnXathoDJAYUVKUUGF/heylloyd-image-1784219377898.webp';
export function Footer() {
  return <footer className="w-full bg-tinta py-12 text-crema/80" data-id="element-41" data-mp="32oe1u0cwejda">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-42" data-mp="32lrmvfnoh1l1">
        <div className="flex flex-col items-center gap-6 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-43" data-mp="36qhf8uj4ny17">
          <div className="flex items-center gap-2.5" data-id="element-44" data-mp="3ufjw405xtmun">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-full bg-crema" data-id="element-45" data-mp="38h456i9zcjd">
              <img src={LOGO_IMG} alt="Logo Cambio Hormonal" className="h-20 w-20 max-w-none object-cover" data-id="element-46" data-mp="3ldalzbekzvhs" />
            </span>
            <span className="leading-tight" data-id="element-47" data-mp="29yxehh44xsnx">
              <span className="block font-serif text-lg font-semibold text-crema" data-id="element-48" data-mp="29xvqkc20tbos">
                Cambio Hormonal
              </span>
              <span className="block text-xs uppercase tracking-[0.2em] text-dorado-light" data-id="element-49" data-mp="3l9ac9f9lwy2u">
                El Método del 1%
              </span>
            </span>
          </div>

          <div className="flex flex-col items-center gap-4 sm:items-end" data-id="element-50" data-mp="3gctrmv1m91ui">
            <a href="mailto:hola@vuelveavivir.com" className="inline-flex items-center gap-2 text-sm text-crema/80 transition-colors hover:text-crema focus:outline-none focus-visible:ring-2 focus-visible:ring-rosa/40 rounded" data-id="element-51" data-mp="3v919vptgrt75">
              <MailIcon className="h-4 w-4" strokeWidth={1.8} data-id="element-52" data-mp="32w1tqajr697" />
              hola@vuelveavivir.com
            </a>
            <nav aria-label="Enlaces legales" className="flex items-center gap-4 text-xs" data-id="element-53" data-mp="hrihxu80021h">
              <a href="#politica-de-privacidad" className="text-crema/65 underline-offset-4 transition-colors hover:text-crema hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-rosa/40 rounded" data-id="element-54" data-mp="cw33b0262240">
                Política de privacidad
              </a>
              <a href="#terminos-de-uso" className="text-crema/65 underline-offset-4 transition-colors hover:text-crema hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-rosa/40 rounded" data-id="element-55" data-mp="ytxylo122j20">
                Términos de uso
              </a>
            </nav>
          </div>
        </div>

        <p className="mt-8 max-w-3xl text-xs leading-relaxed text-crema/55" data-id="element-56" data-mp="1clckq3q9f0da">
          Este programa tiene fines educativos e informativos de bienestar.
        </p>

        <div className="mt-6 grid max-w-3xl gap-3 text-xs leading-relaxed text-crema/55" data-id="element-57" data-mp="1mktogflyb46m">
          <details id="politica-de-privacidad" className="rounded-lg border border-crema/15 px-4 py-3" data-id="element-58" data-mp="1rj4xio4f9ans">
            <summary className="cursor-pointer font-medium text-crema/80 focus:outline-none" data-id="element-59" data-mp="3oczqddx2sn7m">
              Política de privacidad
            </summary>
            <p className="mt-3" data-id="element-60" data-mp="2afncncg8i20a">
              Los datos que compartas al comprar, acceder o contactar se usarán
              únicamente para gestionar tu acceso, atender tus consultas y
              enviarte información relacionada con el programa.
            </p>
          </details>
          <details id="terminos-de-uso" className="rounded-lg border border-crema/15 px-4 py-3" data-id="element-61" data-mp="1wnz0xa9wdfju">
            <summary className="cursor-pointer font-medium text-crema/80 focus:outline-none" data-id="element-62" data-mp="2tcy5ofb9vz7a">
              Términos de uso y responsabilidad
            </summary>
            <p className="mt-3" data-id="element-63" data-mp="2kd1g8bh26wb6">
              Al usar este programa aceptas que tu participación es voluntaria y
              que eres responsable de las decisiones que tomes sobre tu
              bienestar. Este contenido no reemplaza atención médica ni
              profesional, especialmente ante síntomas persistentes o
              condiciones preexistentes.
            </p>
          </details>
        </div>

        <p className="mt-6 text-xs text-crema/50" data-id="element-64" data-mp="2rvhffluoo770">
          © {new Date().getFullYear()} Cambio Hormonal · El Método del 1%.
          Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}